import {NgModule} from "@angular/core";
import {
  NgbDateAdapter,
  NgbDateParserFormatter,
  NgbDatepickerI18n,
  NgbModule,
  NgbNavModule
} from "@ng-bootstrap/ng-bootstrap";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {SwiperModule} from "swiper/angular";
import {MatListModule} from "@angular/material/list";
import {MatBottomSheetModule} from "@angular/material/bottom-sheet";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import {InfiniteScrollModule} from "ngx-infinite-scroll";
import {NgxChartsModule} from "@swimlane/ngx-charts";
import {MatStepperModule} from "@angular/material/stepper";
import {MatDialogModule} from "@angular/material/dialog";
import {NgxMaskModule} from "ngx-mask";
import {DecimalPipe, NgOptimizedImage} from "@angular/common";
import {MatTooltipModule} from "@angular/material/tooltip";
import {RouterModule} from "@angular/router";
import {ShareIconsModule} from "ngx-sharebuttons/icons";
import {ShareButtonsModule} from "ngx-sharebuttons/buttons";
import {
  GoogleSigninButtonModule,
  SocialLoginModule
} from "@abacritt/angularx-social-login";
import {LyIconModule, LyIconService} from "@alyle/ui/icon";
import {LyButtonModule} from "@alyle/ui/button";
import {LySliderModule} from "@alyle/ui/slider";
import {LyImageCropperModule} from "@alyle/ui/image-cropper";
import {
  CustomNgbDatepickerAdapter,
  CustomNgbDatepickerDateParserFormatter,
  CustomNgbDatepickerI18n,
} from "@services";
import {
  CurrencyPipe,
  IsFinishWaypointPipe,
  FormatTimePipe,
  LeagueEventsToGoPipe,
  LocalizedDatePipe,
  RaceLengthFormatPipe,
  RolePipe,
  LeagueRoundPipe,
  ErrorMessagesPipe,
  RaceCompetitorCountFormatPipe,
  RaceAscentDescentFormatPipe,
  RaceAltitudeFormatPipe,
  OrdinalNumberPipe,
  CompetitorFieldValuePipe,
  CompetitorAdditionalPricingValuePipe,
  CategoryTypePipe,
  RaceCommercialItemsMinPriceFormatPipe,
  WaypointLocationPipe,
  TimeLimitPipe,
  ImportStatusPipe,
  CountryPipe,
  RegistrationTypePipe,
  RegistrationTypeNamePipe,
  RegistrationNamePipe,
  LeagueNextRoundPipe,
  ResultsRankPipe,
  TotalTimePipe,
  FinishAndLastCpDiffPipe,
  ResultDateTimePipe,
  NumberOfControlPointsOrLapsPipe,
  ResultsTimePipe,
  FilterByFieldPipe,
  MillisecondsToSecondsPipe,
  GetByFieldPipe,
  ResultsGapTimePipe,
  CompetitorSpeedPipe,
  CompetitorTempoPipe,
  WaypointNameByIdPipe,
  WaypointNameByWaypointIdPipe,
  LtpCompetitorStageDetailPipe,
  RemoveLeadingZerosPipe,
  StringTimeToPrecisionPipe, MillisecondsToPrecisionPipe,
} from "@pipes";
import {LY_THEME, LY_THEME_NAME, LyRippleService, LyTheme2} from "@alyle/ui";
import {MinimaDark, MinimaLight} from "@alyle/ui/themes/minima";
import {ColorMonthPipe} from "./directive/month-color.directive";
import {CustomControlValueAccessorDirective} from "./directive/custom-control.directive";
import {ImageFallbackDirective} from "./directive/image-fallback.directive";
import {NumberFormatterDirective} from "./directive/format-number.directive";
import {
  ActionButtonComponent,
  ActionItemComponent,
  AddDiscountItemModalComponent,
  RaceDetailsModalComponent,
  ShareModalComponent,
  SaveShareComponent,
  RaceMapModalComponent,
  AdditionalPricingItemValueInputComponent,
  AddUserModalComponent,
  AdminCardWithTitleComponent,
  AdminLoadMoreComponent,
  AdminMenuComponent,
  AlertErrorComponent,
  AlertSuccessComponent,
  AlertWarningComponent,
  AppStoreInfoModalContent,
  BadgeComponent,
  BadgeAltComponent,
  TableHeaderSeparatorComponent,
  BadgeWithButtonComponent,
  BreadcrumbsComponent,
  ButtonComponent,
  ButtonWithIconComponent,
  CarouselComponent,
  HeroAltComponent,
  CheckboxComponent,
  CheckmarkIndicatorComponent,
  ConfirmationModalComponent,
  ConfirmationCanvasComponent,
  ConsentComponent,
  RaceProfileModalComponent,
  RegistrationDetailsModalComponent,
  OrganiserContactModalComponent,
  ResultsDetailsModalComponent,
  DateRangeSelectorComponent,
  DateTimeFromToInputComponent,
  DateTimeInputComponent,
  DotIndicatorComponent,
  DownloadAppHeroComponent,
  ClockComponent,
  CompetitorCountComponent,
  DragAndDropComponent,
  DurationInputComponent,
  EmptyStateAdminComponent,
  EntryListItemComponent,
  DropdownComponent,
  DropdownContentDirective,
  DropdownItemDirective,
  DropdownToggleDirective,
  EventGridItemComponent,
  EventGridItemWithImageAlt,
  LeagueGridItemWithImage,
  EventGridItemWithImageSmall,
  FieldConfigValueInputComponent,
  FooterComponent,
  FullScreenFooterComponent,
  FormCardComponent,
  GridItemTitleComponent,
  InputComponent,
  CheckpointInputComponent,
  LanguageInputComponent,
  LanguageInputSwitcherComponent,
  LanguageOutputComponent,
  LanguageSwitcherComponent,
  LiveEventComponent,
  LiveRaceListItemComponent,
  LiveResultsMobileItemComponent,
  LiveResultsRaceHeadingComponent,
  LiveResultsTableBodyComponent,
  LiveResultsTableHeaderComponent,
  LoaderComponent,
  LogoXxlComponent,
  MonthsPickerComponent,
  MultiSelectDropdownComponent,
  MyUpcomingEventComponent,
  MyUpcomingRaceComponent,
  NavTabComponent,
  NavTabsComponent,
  PageHeaderPublicComponent,
  PageHeaderPublicAltComponent,
  PageHeadingComponent,
  PanelComponent,
  RaceDetailsPanelComponent,
  RaceGridItemComponent,
  RacesHeaderComponent,
  RibbonComponent,
  SearchBarComponent,
  SearchBarEventsComponent,
  SearchComponent,
  SelectComponent,
  GreyCardWithTitleComponent,
  HorizontalBoxListComponent,
  HorizontalBoxListItemComponent,
  HeaderAltComponent,
  HeaderBadgeComponent,
  EventListItemComponent,
  FullCropperWidthComponent,
  ResultListItemComponent,
  MailboxListItemComponent,
  ActionButtonsRowComponent,
  AdminActionsHeaderComponent,
  ControlPointsTableComponent,
  RaceProfileComponent,
  EventListItemHeaderComponent,
  EventListItemBigComponent,
  EmptyStateComponent,
  EmptyStateLiveComponent,
  SectionDividerComponent,
  PageHeaderComponent,
  TagsInputComponent,
  RacePricingTableComponent,
  TooltipComponent,
  TooltipDirective,
  ToastComponent,
  PageTemplateComponent,
  TopBannerComponent,
  CompetitorTableComponent,
  ResultsTableComponent,
  TimingCacheOffcanvasComponent,
  ThreeDotsComponent,
  SearchRoundedComponent,
  ValidationModalComponent,
  ValidatorResultMessage,
  NewOrganiserModalComponent,
  ContactsTabComponent,
  SeriesTableComponent,
  TableSectionHeaderComponent,
  ShareCtaComponent,
  TeamListItemComponent,
  InfoSectionPublicComponent,
  YoutubeEmbedComponent,
  SectionSubtitleComponent,
  TextareaComponent,
  TelInputComponent,
  StepperComponent,
  EventsListModalComponent,
  UserListModalComponent,
  SortableTableComponent,
  SpinnerComponent,
  CookieBannerComponent,
  SectionCardComponent,
  RoundedButtonComponent,
  ButtonAltComponent,
  RichTextEditorWrapperComponent,
  RacesToStartCancelEditModalComponent,
  LeafletMapsWrapperComponent,
  EditCompetitorMeasurementTimes,
  DeleteCompetitorMeasurementTimes,
  AcceptCompetitorRegistrationComponent,
  CompetitorTableDropdownActionsRowComponent,
  SelectWaypointFromEventModalComponent,
  AssignChipNumbersModalComponent,
  AddChipTimeModalComponent,
  FavoriteEventIndicatorComponent,
  EditCompetitorRaceComponent,
  EventDateDisplayComponent,
  CalendarComponent,
  MyUpcomingHeadingComponent,
  ImportCompetitorsModalComponent
} from "@components";
import {
  AdminEventDetailsComponent,
  AdminRaceDetailsComponent,
  TeamMembersManagementComponent,
  CategoriesListComponent,
  CategoryFormComponent,
  CategoryItemFormComponent,
  ChangePasswordOnRecoveryComponent,
  ContactComponent,
  AboutComponent,
  DiscountsDetailsComponent,
  ErrorStateComponent,
  EventBasicDataComponent,
  EventCalendarComponent,
  LeagueCalendarComponent,
  EventDetailsComponent,
  EventInfoComponent,
  EventPaymentSettingsComponent,
  EventPreviewComponent,
  LandingComponent,
  ListOfAdministratorsComponent,
  ListOfDiscountsComponent,
  ListOfEventsComponent,
  ListOfOrganisersComponent,
  ListOfRequestsComponent,
  ListOfUsersComponent,
  LiveResultsComponent,
  LiveResultsRaceDetailsComponent,
  LoginComponent,
  MessagesComponent,
  OrganiserBasicDataComponent,
  OrganiserDetailsComponent,
  EventManagementComponent,
  OrganiserPaymentDataFormComponent,
  OrganiserUserListComponent,
  OrganizerDashboardComponent,
  PaymentComponent,
  PrivacyPolicyComponent,
  PoliciesComponent,
  GeneralConditionsComponent,
  IntellectualPropertyComponent,
  CookiePolicyComponent,
  ComplaintsAndDisputesComponent,
  NoticeOnPersonalDataProtectionComponent,
  RaceAdditionalPricingItemCardComponent,
  RaceAdditionalPricingItemFormComponent,
  RaceCommercialItemCardComponent,
  RaceCommercialItemFormComponent,
  RaceDetailsAdditionalInfoComponent,
  RaceDetailsBasicInfoComponent,
  RaceDetailsComponent,
  RaceDetailsPricingComponent,
  RaceDetailsRegistrationSettingsComponent,
  RaceDetailsRegistrationSettingsCustomFieldFormComponent,
  RaceDetailsRegistrationSettingsDefaultFieldFormComponent,
  RaceDetailsSettingsComponent,
  RaceWaypointsComponent,
  RecoverLostPasswordComponent,
  RegisterToRaceComponent,
  RegisterToRaceItemComponent,
  RegisterToRaceFeeItemOutputComponent,
  RegisterToRaceAdditionalItemOutput,
  RequestDetailsComponent,
  SignupComponent,
  SignupVerificationComponent,
  UserDetailsComponent,
  UserDetailsDataComponent,
  UserProfileEditComponent,
  MyTraceyComponent,
  UserProfileDashboardTabComponent,
  UserProfileEventsTabComponent,
  UserProfileWishListTabComponent,
  UserProfileClubsAndTeamsTabComponent,
  RaceResultsListComponentComponent,
  RaceManagementComponentComponent,
  RaceCompetitorsListComponentComponent,
  EventInfoTabComponent,
  LeagueInfoTabComponent,
  LeagueResultsTabComponent,
  LeagueDetailsComponent,
  ListOfAccountStatementsComponent,
  AccountStatementDetailsComponent,
  ListOfLeaguesComponent,
  EventManagementRaceListComponent,
  EventManagementParticipantsListComponent,
  EventManagementRegistrationsListComponent,
  AdminLeagueDetailsComponent,
  LeagueBasicDataComponent,
  RaceMapTabComponent,
  LeagueEventListTabComponent,
  AdminTemplateComponent,
  EventMeasurementsManagementComponent,
  EventMeasurementsManagementRaceListComponent,
  EventMeasurementsPointsLapsComponent,
  TeamMembersManagementFormComponent,
  EventContactsTabComponent,
  TestComponent,
  TimingComponent,
  TimerComponent
} from "@pages";
import {SortableColumn} from "./directive/sortable-column.directive";
import {TranslocoModule} from "@ngneat/transloco";
import {CompetitorMobileFieldsPipe, FilterCompetitorTableRowDataPipe} from "./pipes/competitor-table-pipes";

@NgModule({
  declarations: [
    AdditionalPricingItemValueInputComponent,
    AssignChipNumbersModalComponent,
    AddChipTimeModalComponent,
    ActionButtonComponent,
    ActionItemComponent,
    AdminCardWithTitleComponent,
    AdminLoadMoreComponent,
    CarouselComponent,
    HeroAltComponent,
    DateRangeSelectorComponent,
    FieldConfigValueInputComponent,
    FooterComponent,
    FullScreenFooterComponent,
    PageHeaderComponent,
    PageHeaderPublicAltComponent,
    ButtonComponent,
    ButtonWithIconComponent,
    PanelComponent,
    BadgeComponent,
    BadgeAltComponent,
    TableHeaderSeparatorComponent,
    BadgeWithButtonComponent,
    MultiSelectDropdownComponent,
    MyUpcomingEventComponent,
    MyUpcomingHeadingComponent,
    MyUpcomingRaceComponent,
    TagsInputComponent,
    LandingComponent,
    TestComponent,
    ContactComponent,
    AboutComponent,
    PrivacyPolicyComponent,
    PoliciesComponent,
    GeneralConditionsComponent,
    IntellectualPropertyComponent,
    CookiePolicyComponent,
    ComplaintsAndDisputesComponent,
    NoticeOnPersonalDataProtectionComponent,
    RaceGridItemComponent,
    RacePricingTableComponent,
    TooltipComponent,
    TooltipDirective,
    RaceProfileComponent,
    RacesHeaderComponent,
    EventGridItemComponent,
    EventGridItemWithImageAlt,
    LeagueGridItemWithImage,
    EventGridItemWithImageSmall,
    MonthsPickerComponent,
    DownloadAppHeroComponent,
    SignupComponent,
    LoginComponent,
    SearchBarComponent,
    SearchBarEventsComponent,
    SpinnerComponent,
    CookieBannerComponent,
    SignupVerificationComponent,
    RecoverLostPasswordComponent,
    ChangePasswordOnRecoveryComponent,
    LanguageSwitcherComponent,
    FormCardComponent,
    SectionDividerComponent,
    RaceDetailsComponent,
    RaceMapTabComponent,
    EventDetailsComponent,
    RegisterToRaceComponent,
    EventManagementRaceListComponent,
    EventManagementParticipantsListComponent,
    EventManagementRegistrationsListComponent,
    RegisterToRaceItemComponent,
    RegisterToRaceFeeItemOutputComponent,
    RegisterToRaceAdditionalItemOutput,
    ToastComponent,
    ClockComponent,
    CompetitorCountComponent,
    PageTemplateComponent,
    TopBannerComponent,
    RibbonComponent,
    CompetitorTableComponent,
    ResultsTableComponent,
    ErrorStateComponent,
    PaymentComponent,
    LiveResultsComponent,
    EmptyStateComponent,
    EmptyStateLiveComponent,
    EmptyStateAdminComponent,
    TimingCacheOffcanvasComponent,
    ThreeDotsComponent,
    DotIndicatorComponent,
    LiveResultsTableHeaderComponent,
    LiveEventComponent,
    LiveRaceListItemComponent,
    LiveResultsRaceHeadingComponent,
    LiveResultsRaceDetailsComponent,
    EventCalendarComponent,
    LeagueCalendarComponent,
    LandingComponent,
    TestComponent,
    UserProfileEditComponent,
    MyTraceyComponent,
    UserProfileDashboardTabComponent,
    UserProfileEventsTabComponent,
    UserProfileWishListTabComponent,
    UserProfileClubsAndTeamsTabComponent,
    AppStoreInfoModalContent,
    SearchComponent,
    SearchRoundedComponent,
    AlertWarningComponent,
    AlertErrorComponent,
    AlertSuccessComponent,
    LiveResultsMobileItemComponent,
    LiveResultsTableBodyComponent,
    BreadcrumbsComponent,
    ListOfRequestsComponent,
    RequestDetailsComponent,
    UserDetailsComponent,
    UserDetailsDataComponent,
    ListOfAdministratorsComponent,
    ListOfUsersComponent,
    OrganiserDetailsComponent,
    EventBasicDataComponent,
    DateTimeFromToInputComponent,
    OrganiserBasicDataComponent,
    AdminTemplateComponent,
    ListOfEventsComponent,
    ListOfOrganisersComponent,
    OrganiserUserListComponent,
    AdminEventDetailsComponent,
    TeamMembersManagementComponent,
    TeamMembersManagementFormComponent,
    EventInfoComponent,
    AdminRaceDetailsComponent,
    OrganizerDashboardComponent,
    OrganiserPaymentDataFormComponent,
    ConfirmationModalComponent,
    ConfirmationCanvasComponent,
    ConsentComponent,
    RegistrationDetailsModalComponent,
    RaceProfileModalComponent,
    ValidationModalComponent,
    ValidatorResultMessage,
    OrganiserContactModalComponent,
    ResultsDetailsModalComponent,
    AddUserModalComponent,
    NewOrganiserModalComponent,
    LanguageInputSwitcherComponent,
    EventPaymentSettingsComponent,
    RolePipe,
    ResultsRankPipe,
    TotalTimePipe,
    FinishAndLastCpDiffPipe,
    CompetitorSpeedPipe,
    CompetitorTempoPipe,
    WaypointNameByIdPipe,
    WaypointNameByWaypointIdPipe,
    LtpCompetitorStageDetailPipe,
    ResultsGapTimePipe,
    ResultDateTimePipe,
    ErrorMessagesPipe,
    RaceLengthFormatPipe,
    RaceCompetitorCountFormatPipe,
    RaceCommercialItemsMinPriceFormatPipe,
    RaceAscentDescentFormatPipe,
    RaceAltitudeFormatPipe,
    OrdinalNumberPipe,
    CompetitorFieldValuePipe,
    CompetitorAdditionalPricingValuePipe,
    CurrencyPipe,
    ImportStatusPipe,
    FilterCompetitorTableRowDataPipe,
    CompetitorMobileFieldsPipe,
    NumberOfControlPointsOrLapsPipe,
    CountryPipe,
    FilterByFieldPipe,
    GetByFieldPipe,
    MillisecondsToSecondsPipe,
    WaypointLocationPipe,
    NumberFormatterDirective,
    SortableColumn,
    CustomControlValueAccessorDirective,
    ColorMonthPipe,
    TimeLimitPipe,
    IsFinishWaypointPipe,
    AdminMenuComponent,
    CheckmarkIndicatorComponent,
    RaceWaypointsComponent,
    RaceDetailsBasicInfoComponent,
    DragAndDropComponent,
    RaceCompetitorsListComponentComponent,
    RaceResultsListComponentComponent,
    RaceManagementComponentComponent,
    RaceDetailsAdditionalInfoComponent,
    RaceDetailsSettingsComponent,
    RaceDetailsPricingComponent,
    RaceAdditionalPricingItemFormComponent,
    RaceCommercialItemFormComponent,
    RaceCommercialItemCardComponent,
    RaceAdditionalPricingItemCardComponent,
    LanguageInputComponent,
    RaceDetailsRegistrationSettingsComponent,
    RaceDetailsRegistrationSettingsCustomFieldFormComponent,
    RaceDetailsRegistrationSettingsDefaultFieldFormComponent,
    LanguageOutputComponent,
    GridItemTitleComponent,
    EventManagementComponent,
    EventMeasurementsManagementComponent,
    EventMeasurementsManagementRaceListComponent,
    EventMeasurementsPointsLapsComponent,
    ListOfDiscountsComponent,
    MessagesComponent,
    DiscountsDetailsComponent,
    CategoriesListComponent,
    CategoryTypePipe,
    RegistrationTypePipe,
    RegistrationTypeNamePipe,
    RegistrationNamePipe,
    LocalizedDatePipe,
    LeagueEventsToGoPipe,
    LeagueNextRoundPipe,
    LeagueRoundPipe,
    FormatTimePipe,
    ResultsTimePipe,
    RemoveLeadingZerosPipe,
    StringTimeToPrecisionPipe,
    MillisecondsToPrecisionPipe,
    EventPreviewComponent,
    CalendarComponent,
    DateTimeInputComponent,
    DurationInputComponent,
    DropdownComponent,
    SortableTableComponent,
    EventDateDisplayComponent,
    DropdownToggleDirective,
    DropdownContentDirective,
    DropdownItemDirective,
    CategoryFormComponent,
    CategoryItemFormComponent,
    UserListModalComponent,
    AddDiscountItemModalComponent,
    RaceDetailsModalComponent,
    ShareModalComponent,
    SaveShareComponent,
    RaceMapModalComponent,
    NavTabsComponent,
    NavTabComponent,
    EventsListModalComponent,
    ImageFallbackDirective,
    RaceDetailsPanelComponent,
    StepperComponent,
    InputComponent,
    CheckpointInputComponent,
    SelectComponent,
    TelInputComponent,
    ControlPointsTableComponent,
    TextareaComponent,
    CheckboxComponent,
    SelectComponent,
    LogoXxlComponent,
    SectionSubtitleComponent,
    EntryListItemComponent,
    EventInfoTabComponent,
    EventContactsTabComponent,
    LeagueInfoTabComponent,
    LeagueResultsTabComponent,
    LeagueDetailsComponent,
    YoutubeEmbedComponent,
    LoaderComponent,
    PageHeaderPublicComponent,
    PageHeaderPublicAltComponent,
    InfoSectionPublicComponent,
    GreyCardWithTitleComponent,
    FullCropperWidthComponent,
    HorizontalBoxListComponent,
    HorizontalBoxListItemComponent,
    ImportCompetitorsModalComponent,
    HeaderAltComponent,
    HeaderBadgeComponent,
    EventListItemComponent,
    ResultListItemComponent,
    MailboxListItemComponent,
    TeamListItemComponent,
    ShareCtaComponent,
    ActionButtonsRowComponent,
    AdminActionsHeaderComponent,
    ListOfAccountStatementsComponent,
    AccountStatementDetailsComponent,
    ListOfLeaguesComponent,
    AdminLeagueDetailsComponent,
    LeagueBasicDataComponent,
    EventListItemHeaderComponent,
    EventListItemBigComponent,
    LeagueEventListTabComponent,
    TableSectionHeaderComponent,
    SeriesTableComponent,
    ContactsTabComponent,
    LeafletMapsWrapperComponent,
    RichTextEditorWrapperComponent,
    RacesToStartCancelEditModalComponent,
    EditCompetitorMeasurementTimes,
    DeleteCompetitorMeasurementTimes,
    AcceptCompetitorRegistrationComponent,
    EditCompetitorRaceComponent,
    CompetitorTableDropdownActionsRowComponent,
    SelectWaypointFromEventModalComponent,
    FavoriteEventIndicatorComponent,
    TopBannerComponent,
    TimingComponent,
    TimerComponent
  ],
  imports: [
    NgbModule,
    NgbNavModule,
    TranslocoModule,
    FormsModule,
    SocialLoginModule,
    MatListModule,
    MatBottomSheetModule,
    MatIconModule,
    MatButtonModule,
    InfiniteScrollModule,
    NgxChartsModule,
    ReactiveFormsModule,
    MatStepperModule,
    MatDialogModule,
    NgxMaskModule.forRoot(),
    NgOptimizedImage,
    MatTooltipModule,
    SwiperModule,
    LyImageCropperModule,
    LySliderModule,
    LyIconModule,
    LyButtonModule,
    ShareButtonsModule,
    ShareIconsModule,
    GoogleSigninButtonModule,
    RouterModule,
    ReactiveFormsModule,
    SectionCardComponent,
    PageHeadingComponent,
    RoundedButtonComponent,
    ButtonAltComponent],
  exports: [SpinnerComponent, ToastComponent, CookieBannerComponent],
  providers: [
    {provide: NgbDatepickerI18n, useClass: CustomNgbDatepickerI18n},
    {provide: NgbDateAdapter, useClass: CustomNgbDatepickerAdapter},
    {provide: NgbDateParserFormatter, useClass: CustomNgbDatepickerDateParserFormatter},
    CurrencyPipe,
    FilterByFieldPipe,
    ColorMonthPipe,
    RaceLengthFormatPipe,
    LocalizedDatePipe,
    ErrorMessagesPipe,
    LeagueEventsToGoPipe,
    LeagueNextRoundPipe,
    LeagueRoundPipe,
    FormatTimePipe,
    DecimalPipe,
    RolePipe,
    RegistrationTypePipe,
    RegistrationTypeNamePipe,
    TimeLimitPipe,
    CategoryTypePipe,
    RegistrationNamePipe,
    LyTheme2,
    LyRippleService,
    LyIconService,
    {provide: LY_THEME_NAME, useValue: 'minima-light'},
    {provide: LY_THEME, useClass: MinimaLight, multi: true}, // name: `minima-light`
    {provide: LY_THEME, useClass: MinimaDark, multi: true},
  ]
})
export class AppModule {
}
